import { PartnerEntity } from "@/models/partnerEntity";
import { PartnerTypeEnum } from "../enum/partner/partner.type.enum";

export function mapPartnerDtoToViewModel(partnerDto: PartnerEntity): PartnerEntity {
  const partnerViewModel: PartnerEntity = {
    _id: getNested(partnerDto, "_id") || "",
    companyName: getNested(partnerDto, "companyName") || "",
    companyUsername: getNested(partnerDto, "companyUsername") || "",
    logo: getNested(partnerDto, "logo ") || "",
    partnerType: getNested(partnerDto, "partnerType") || PartnerTypeEnum.WORKSHOP,
    editors: getNested(partnerDto, "editors ") || [],
    assignedCases: getNested(partnerDto, "assignedCases ") || [],
    contact: {
      email: getNested(partnerDto, "contact", "email") || "",
      phone: getNested(partnerDto, "contact", "phone") || ""
    },
    address: {
      street: getNested(partnerDto, "address", "street") || "",
      zip: getNested(partnerDto, "address", "zip") || "",
      city: getNested(partnerDto, "address", "city") || "",
      state: getNested(partnerDto, "address", "state") || "",
      countryCode: getNested(partnerDto, "address", "countryCode") || "",
      geo: {
        lat: getNested(partnerDto, "address", "geo", "lat") || 0,
        lng: getNested(partnerDto, "address", "geo", "lng") || 0
      }
    },
    settings: {
      color: getNested(partnerDto, "settings", "color") || "#888888",
      contact: {
        email: getNested(partnerDto, "settings", "contact", "email") || "",
        phone: getNested(partnerDto, "settings", "contact", "phone") || ""
      },
      headerImageUrl: getNested(partnerDto, "settings", "headerImageUrl") || "",
      logoUrl: getNested(partnerDto, "settings", "logoUrl") || "",
      displayMap: getNested(partnerDto, "settings", "displayMap") || false,
      openingHours: {
        monday: getNested(partnerDto, "settings", "openingHours", "monday") || "Geschlossen",
        tuesday: getNested(partnerDto, "settings", "openingHours", "tuesday") || "Geschlossen",
        wednesday: getNested(partnerDto, "settings", "openingHours", "wednesday") || "Geschlossen",
        thursday: getNested(partnerDto, "settings", "openingHours", "thursday") || "Geschlossen",
        friday: getNested(partnerDto, "settings", "openingHours", "friday") || "Geschlossen",
        saturday: getNested(partnerDto, "settings", "openingHours", "saturday") || "Geschlossen",
        sunday: getNested(partnerDto, "settings", "openingHours", "sunday") || "Geschlossen"
      },
      websites: getNested(partnerDto, "settings", "websites") || [],
      favIconUrl: getNested(partnerDto, "settings", "favIconUrl") || "",
      cardText: getNested(partnerDto, "settings", "cardText") || "",
      cardSubtitle: getNested(partnerDto, "settings", "cardSubtitle") || "",
      cardTitle: getNested(partnerDto, "settings", "cardTitle") || "",
      formTitle: getNested(partnerDto, "settings", "formTitle") || "",
      reportSettings: {
        logoUrl: getNested(partnerDto, "settings", "reportSettings", "logoUrl") || "",
        headerImageUrl: getNested(partnerDto, "settings", "reportSettings", "headerImageUrl") || "",
        favIconUrl: getNested(partnerDto, "settings", "reportSettings", "favIconUrl") || "",
        firstColor: getNested(partnerDto, "settings", "reportSettings", "firstColor") || "",
        secondColor: getNested(partnerDto, "settings", "reportSettings", "secondColor") || "",
        screenOrder: getNested(partnerDto, "settings", "reportSettings", "screenOrder") || [],
        screens: getNested(partnerDto, "settings", "reportSettings", "screens") || []
      },
      emailSettings: {
        registrationShowResults: getNested(partnerDto, "settings", "emailSettings", "registrationShowResults") || false,
        registrationShowKsrButton:
          getNested(partnerDto, "settings", "emailSettings", "registrationShowKsrButton") || false
      },
      bookedServices: {
        registrationService: getNested(partnerDto, "settings", "bookedServices", "registrationService") || false,
        form: getNested(partnerDto, "settings", "bookedServices", "form") || false,
        report: getNested(partnerDto, "settings", "bookedServices", "report") || false,
        payment: getNested(partnerDto, "settings", "bookedServices", "payment") || false
      },
      urls: getNested(partnerDto, "settings", "urls") || []
    },
    timestamps: {
      created: getNested(partnerDto, "timestamps", "created") || new Date().toISOString()
    }
  };

  return partnerViewModel;
}

function getNested(obj: any, ...args: any[]) {
  return args.reduce((obj, level) => obj && obj[level], obj);
}
